<template>
  <el-table-column
    v-bind="$attrs"
  >
    <template slot-scope="scope">
      <progress-bar :value="scope.row[$attrs.prop]" :percentage="percentage(scope.row)" />
    </template>
  </el-table-column>
</template>

<script>
  import ProgressBar from '@/components/common/ProgressBar'
  import { differenceInDays } from 'date-fns'

  export default {
    components: {
      ProgressBar
    },
    methods: {
      percentage(classData) {
        if(classData.start_date && classData.end_date) {
          const startDate = new Date(classData.start_date)
          const endDate = new Date(classData.end_date)

          const duration = differenceInDays(endDate, startDate)
          const daysPassed = differenceInDays(Date.now(), startDate)

          return (daysPassed/duration) * 100
        }

        return 75
      }
    },
  }
</script>

<style lang="scss" scoped>

::v-deep.progress-wrapper {
  flex-direction: column;
}

</style>
